import { FolioServicesStateInterface } from '.';

function state(): FolioServicesStateInterface {
  return {
    folioServices: [],
  };
}

export default state;
